
import { types, actions } from './requests'
export const DELETEVARIANT_TYPES = {
    ...types('DELETEVARIANT'),
}
export const DELETEVARIANT_ACTIONS = {
    ...actions('DELETEVARIANT'),
}